import type { ReactNode } from "react";
import { OG_IMAGE_URL, canonicalUrl } from "@/lib/seoConstants";
import type { OgLocale } from "@/locale/appLang";

type Props = {
  /** Путь без домена, например `/devops-outsourcing` */
  path: string;
  title: string;
  description: string;
  ogLocale?: OgLocale;
  ogImage?: string;
};

const OG_LOCALES: OgLocale[] = ["ru_RU", "uk_UA", "kk_KZ", "uz_UZ", "ky_KG"];

export function seoOpenGraphNodes({
  path,
  title,
  description,
  ogLocale = "ru_RU",
  ogImage = OG_IMAGE_URL,
}: Props): ReactNode {
  const url = canonicalUrl(path);
  const alternates = OG_LOCALES.filter((loc) => loc !== ogLocale);
  const image = ogImage || OG_IMAGE_URL;
  return (
    <>
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={ogLocale} />
      {alternates.map((loc) => (
        <meta key={loc} property="og:locale:alternate" content={loc} />
      ))}
      <meta property="og:site_name" content="IT-24.pro" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </>
  );
}
